import React from "react";

export default function(props) {
  return (
    <span
      style={{
        borderTop: "1px solid #E6EBF0",
        boxShadow: props.hasShadow && "0 1px 5px 0 rgba(20,155,236,0.11)",
        width: "100%",
        display: "block",
        position: "relative",
        top: "-2px",
        marginTop: props.m,
        marginBottom: props.m
      }}
    />
  );
}
